import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const RefreshComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__refresh"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_4213_14960)">
        <path
          d="M15.3333 2.66675V6.66675H11.3333"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666748 13.3333V9.33325H4.66675"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.34008 5.99989C2.67819 5.04441 3.25284 4.19016 4.01039 3.51683C4.76795 2.84351 5.68373 2.37306 6.67227 2.14939C7.66082 1.92572 8.68992 1.95612 9.66354 2.23774C10.6372 2.51936 11.5236 3.04303 12.2401 3.75989L15.3334 6.66655M0.666748 9.33322L3.76008 12.2399C4.47658 12.9567 5.363 13.4804 6.33662 13.762C7.31025 14.0437 8.33934 14.0741 9.32789 13.8504C10.3164 13.6267 11.2322 13.1563 11.9898 12.4829C12.7473 11.8096 13.322 10.9554 13.6601 9.99989"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4213_14960">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Refresh = withIcon(RefreshComponent);
